import styled from 'styled-components';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { COLOUR_CONSTANT } from '../../../utils/contants';

export const ListItemIconStyled = styled(ListItemIcon)`
  min-width: 20px !important;
  display: flex;
  justify-content: center;
`;

export const ListItemTextStyled = styled(ListItemText)`
  font-size: 13px;
  color: ${(props) => (props?.variant === 'light' ? '#301d35' : '#fff')} !important;
`;

export const MenuStyled = styled(Menu)`
  .MuiList-root {
    padding: 0px;
  }
  .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper.css-14letzj-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {
    box-shadow:
      0px 1px 3px 0px rgba(0, 0, 0, 0.1),
      0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  }
`;
export const MenuItemStyled = styled(MenuItem)`
  font-size: 11px;
  column-gap: 10px;
  padding: 4px 8px;
  border-bottom: none !important;
  /* width: 130px; */
  height: 56px;
  z-index: 100000;
  /* background: red !important; */
  width: ${(props) => `${props?.width}px`} !important;

  border: ${(props) => (props?.noBorder ? '' : '1px solid #301D35')} !important;

  background: ${(props) => (props?.variant === 'light' ? '#fff' : '#301D35')} !important;

  &:hover {
    background-color: ${COLOUR_CONSTANT.theme.lightPink} !important;
  }
`;
